import { FC } from 'react';
import { ActionItemIcon } from './style';
import mime from 'mime';

import ImageIcon from '@mui/icons-material/Image';
import { getFileTypeFromExt } from 'xeniautils';

import sopIcon from 'components/Icons/sopIcon';
import excelIcon from 'components/Icons/excelIcon';
import pptIcon from 'components/Icons/pptIcon';
import wordIcon from 'components/Icons/wordIcon';
import pdfIcon from 'components/Icons/pdfIcon';
import videoIcon from 'components/Icons/videoUploadedIcon';

interface AttachmentIconInterface {
  fileType: string;
  size?: 'large' | 'medium' | 'small';
  file?: any;
}

export const fileTypes = {
  pdf: {
    icon: pdfIcon,
    styles: {
      width: 24,
      height: 24,
      color: 'white',
    },
    bgColor: '#E53935',
  },
  sop: {
    icon: sopIcon,
    styles: {
      width: 22,
      height: 22,
      color: 'white',
    },
    bgColor: '#6868FE',
  },
  word: {
    icon: wordIcon,
    styles: {
      width: 22,
      height: 22,
      color: 'white',
    },
    bgColor: '#1E88E5',
  },
  excel: {
    icon: excelIcon,
    styles: {
      width: 22,
      height: 22,
      color: 'white',
    },
    bgColor: '#43A047',
  },
  ppt: {
    icon: pptIcon,
    styles: {
      width: 22,
      height: 22,
      color: 'white',
    },
    bgColor: '#F4511E',
  },
  video: {
    icon: videoIcon,
    styles: {
      width: 22,
      height: 22,
      color: 'white',
    },
    bgColor: '#D81B60',
  },
  image: {
    icon: ImageIcon,
    styles: {
      width: 22,
      height: 22,
      color: 'white',
      '& path': {
        fill: 'white',
      },
    },
    bgColor: '#00ACC1',
  },
};
const AttachmentIcon: FC<AttachmentIconInterface> = (props) => {
  const { fileType, size = 'medium', file } = props;
  const fileTypeData = (fileType) => {
    if (fileType && fileType !== 'sop') {
      const ext = mime.getExtension(fileType)?.toString();

      const type = getFileTypeFromExt(ext);
      return type ? fileTypes[type] : null;
    } else {
      return fileTypes['sop'];
    }
  };
  const fileData: any = fileTypeData?.(fileType);

  return (
    <ActionItemIcon
      sx={{
        ...(size === 'small' && {
          width: '24px',
          height: '24px',
          flex: '0 0 24px',
          '& > svg': {
            width: '16px',
            height: '16px',
          },
        }),
        ...(size === 'large' && {
          width: '48px',
          height: '48px',
          flex: '0 0 24px',
          '& > svg': {
            width: '36px',
            height: '36px',
          },
        }),
      }}
      bgcolor={fileData?.bgColor}
      svgdimensions={fileData?.styles ?? null}
    >
      {file?.fileType === 'image' || file?.type?.includes('image') ? (
        <img
          src={file?.path ?? file?.url}
          alt="attachment"
          style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            borderRadius: '8px',
          }}
        />
      ) : (
        <fileData.icon />
      )}
    </ActionItemIcon>
  );
};

export default AttachmentIcon;
